import { TenantDashboard } from "@/features/tenants";
import { createFileRoute } from "@tanstack/react-router";
import { verifyRoles } from "../../../utils/verifyRoles";

export const Route = createFileRoute("/dashboard/tenants/")({
  component: TenantDashboard,
  head: () => ({
    meta: [
      { title: "Servidores de autorização - Backoffice Detentora Iniciador" },
    ],
  }),
  beforeLoad: () => verifyRoles(["INIC_ADMIN", "ORG_ADMIN"]),
});
